import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { useLoadingOverlay } from 'modules/components/layer00';
import { TabMetricSectionLayout } from 'modules/components/layer32';
import * as ds from './dataService';



export type RevenueBreakdownSectionProps = {
  listedCompanyId: string;
};

export const FC = (props: RevenueBreakdownSectionProps) => {
  const {
    data,
    loading
  } = ds.useQuery(props.listedCompanyId);

  useLoadingOverlay({
    loading
  });

  return (
    <TabMetricSectionLayout.FC
      title='Revenue Breakdown'
    >
      {data.productSegments.length > 0 && (
        <>
          <Typography variant='h6'>By Product</Typography>
          <DataTable
            years={data.years}
            segments={data.productSegments}
          />
        </>
      )}

      {data.geographySegments.length > 0 && (
        <>
          <Typography variant='h6'>By Geography</Typography>
          <DataTable
            years={data.years}
            segments={data.geographySegments}
          />
        </>
      )}
    </TabMetricSectionLayout.FC>
  );
};



// TODO: This should be its own component. Didn't do it due to deadline.
export const DataTable = ({
  years, segments
}: {
  years: number[];
  segments: ds.ISegment[];
}) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell />
            {years.map((year) => (<TableCell key={year}>{year}</TableCell>))}
          </TableRow>
        </TableHead>

        <TableBody>
          {segments.map((segment) => (
            <TableRow key={segment.label}>
              <TableCell
                sx={{
                  width: 300
                }}
              >{segment.label}
              </TableCell>
              {years.map((year) => {
                const datum = segment.values.find((v) => v.year === year);

                return (
                  <TableCell key={`${segment.label}-${year}`}>
                    {datum?.value ?? '-'}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
